<template>
  <div class="border-wrap" :class="{ 'border-wrap__large': size === 'large' }">
    <div class="title" v-if="title">{{ title }}</div>
    <div class="content">
      <slot>
        <v-chart v-if="!isEmpty" @click="handleClick" :options="options" :autoresize="true" />
        <div class="no-data" v-else>{{ $t('暂无数据') }}</div>
      </slot>
    </div>
  </div>
</template>

<script>
import { isEmpty, isObject } from '@/utils/is';
export default {
  props: {
    title: String,
    options: {
      type: [Object, null],
      default: null
    },
    size: {
      type: String,
      default: 'normal'
    }
  },
  data() {
    return {};
  },
  methods: {
    handleClick(series) {
      this.$emit('click', series);
    }
  },
  computed: {
    isEmpty() {
      return (
        !isObject(this.options) ||
        !isObject(this.options.dataset) ||
        isEmpty(this.options.dataset.source)
      );
    }
  }
};
</script>

<style lang="scss">
.border-wrap {
  background-image: url('~@/assets/image/customs/border-style.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;

  backdrop-filter: blur(5px);

  font-size: calc(var(--base-font-size) * 1.2);

  user-select: none;

  display: flex;
  flex-direction: column;

  height: 100%;

  &.border-wrap__large {
    background-image: url('~@/assets/image/customs/border-style-large.png');
  }

  .title {
    color: #fff;

    padding: 5px 0 0 10px;
  }

  .content {
    height: calc(100% - 24px);
  }

  .no-data {
    height: 100%;
    color: #0ef;
    font-weight: bold;
    font-size: 18px;
    letter-spacing: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
